import { Component, afterNextRender, inject, input, signal } from '@angular/core';
import { ParagraphPgPnav } from '@app/models/paragraph.model';
import { MobiUiIconComponent } from '@mobi/rwc-ui-components-ng-jslib';
import { Url } from '@app/models/global.model';
import { DOCUMENT } from '@angular/common';
import { BreakpointService } from '@app/services/breakpoint.service';
import { AnchorFormatterPipe } from '@app/pipes/anchor-formatter.pipe';
import { BetterRouterLinkDirective } from '@app/directives/better-router-link.directive';
import { ExtractUrlPipe } from '@app/pipes/extract-url.pipe';
import { StickyComponent } from '@app/components/content-links/sticky/sticky.component';
import { MobiTrackingDirective } from '@app/directives/mobi-tracking.directive';

@Component({
  selector: 'mobi-content-links',
  templateUrl: './content-links.component.html',
  styleUrls: ['./content-links.component.scss'],
  standalone: true,
  imports: [
    BetterRouterLinkDirective,
    ExtractUrlPipe,
    MobiUiIconComponent,
    MobiTrackingDirective,
    StickyComponent,
  ],
})
export class ContentLinksComponent {
  readonly contentLinks = input.required<ParagraphPgPnav[]>();
  readonly otherLinks = input<Url[]>([]);
  readonly isCentered = input(false);

  initialized = signal(false);

  #anchorFormatter = new AnchorFormatterPipe();
  #doc = inject(DOCUMENT);
  breakpoint = inject(BreakpointService);

  #afterRender = afterNextRender({
    write: () => {
      this.#doc?.dispatchEvent(new CustomEvent('reinit:tracking'));
      this.initialized.set(true);
    },
  });

  formatLink(link: ParagraphPgPnav): string {
    return link.url
      ? '#' + link.url
      : '#' + this.#anchorFormatter.transform(link.sectionId);
  }
}
